import { Record } from "../fable_modules/fable-library.3.7.20/Types.js";
import { obj_type, equals, list_type, int32_type, option_type, class_type, record_type, string_type } from "../fable_modules/fable-library.3.7.20/Reflection.js";
import { UrlKind, ValidatedUrlModule_create } from "../HttpV2.js";
import { singleton } from "../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { FSharpResult$2 } from "../fable_modules/fable-library.3.7.20/Choice.js";
import { some, defaultArg } from "../fable_modules/fable-library.3.7.20/Option.js";
import { CaseStrategy } from "../fable_modules/Thoth.Json.10.2.0/Types.fs.js";
import { Auto_generateBoxedDecoder_79988AEF, fromString } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { uncurry } from "../fable_modules/fable-library.3.7.20/Util.js";
import { ValidatedUrlModule_value, addClientReference, getCsrfEnabledRequest, Http_get_ExtraCoders } from "../HttpV2.js";
import { Auto_generateBoxedEncoder_Z20B7B430, toString } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Http_send, Http_request, Http_method, Http_content, Http_withCredentials } from "../fable_modules/Fable.SimpleHttp.3.0.0/Http.fs.js";
import { HttpMethod, BodyContent } from "../fable_modules/Fable.SimpleHttp.3.0.0/Types.fs.js";
import { printf, toText } from "../fable_modules/fable-library.3.7.20/String.js";
import { setInvoiceeFees, FeeDTO$reflection } from "../Redux/Reducers/InvoiceeReducer.js";
import { createThunk } from "../Redux/Redux.js";
import { LoadState$2 } from "../Global.js";
import { startImmediate } from "../fable_modules/fable-library.3.7.20/Async.js";

export class Attribute extends Record {
    constructor(Name, Value) {
        super();
        this.Name = Name;
        this.Value = Value;
    }
}

export function Attribute$reflection() {
    return record_type("Api.Fee.Attribute", [], Attribute, () => [["Name", string_type], ["Value", string_type]]);
}

export class CreateFeeDTOV2 extends Record {
    constructor(InvoiceeNr, ContractNr, FeeTemplateNr, StartDate, Type, AmountExclVat, VatPercentage, Description, AccountNo, MonthsInAdvance, BoundMonths, CancellationPeriodMonths, EndDate, Attributes, Units) {
        super();
        this.InvoiceeNr = InvoiceeNr;
        this.ContractNr = ContractNr;
        this.FeeTemplateNr = FeeTemplateNr;
        this.StartDate = StartDate;
        this.Type = Type;
        this.AmountExclVat = AmountExclVat;
        this.VatPercentage = VatPercentage;
        this.Description = Description;
        this.AccountNo = AccountNo;
        this.MonthsInAdvance = MonthsInAdvance;
        this.BoundMonths = BoundMonths;
        this.CancellationPeriodMonths = CancellationPeriodMonths;
        this.EndDate = EndDate;
        this.Attributes = Attributes;
        this.Units = Units;
    }
}

export function CreateFeeDTOV2$reflection() {
    return record_type("Api.Fee.CreateFeeDTOV2", [], CreateFeeDTOV2, () => [["InvoiceeNr", option_type(class_type("System.Int64"))], ["ContractNr", option_type(int32_type)], ["FeeTemplateNr", option_type(int32_type)], ["StartDate", class_type("System.DateOnly")], ["Type", string_type], ["AmountExclVat", class_type("System.Decimal")], ["VatPercentage", option_type(class_type("System.Decimal"))], ["Description", string_type], ["AccountNo", option_type(int32_type)], ["MonthsInAdvance", option_type(int32_type)], ["BoundMonths", option_type(int32_type)], ["CancellationPeriodMonths", option_type(int32_type)], ["EndDate", option_type(class_type("System.DateOnly"))], ["Attributes", list_type(Attribute$reflection())], ["Units", option_type(int32_type)]]);
}

export function createFeeV2(clientNr, dto) {
    const matchValue_1 = ValidatedUrlModule_create(new UrlKind(1, (dto.FeeTemplateNr != null) ? (`/fees/${clientNr}/createFromTemplate`) : (`/fees/${clientNr}`)));
    if (matchValue_1.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue_1.fields[0]));
    }
    else {
        const requestCaseStrategy_1 = defaultArg(new CaseStrategy(1), new CaseStrategy(0));
        let parseFn;
        const arg = defaultArg(new CaseStrategy(1), new CaseStrategy(0));
        parseFn = ((arg_1) => {
            const str = arg_1;
            return equals(CreateFeeDTOV2$reflection(), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(CreateFeeDTOV2$reflection(), arg, Http_get_ExtraCoders().Value)), str);
        });
        const jsonStr = toString(0, Auto_generateBoxedEncoder_Z20B7B430(option_type(CreateFeeDTOV2$reflection()), requestCaseStrategy_1, Http_get_ExtraCoders().Value, false)(dto));
        return singleton.Delay(() => {
            let a;
            return singleton.Bind((a = getCsrfEnabledRequest(addClientReference(Http_withCredentials(true, Http_content(new BodyContent(1, jsonStr), Http_method(new HttpMethod(1), Http_request(ValidatedUrlModule_value(matchValue_1.fields[0]))))))), singleton.Bind(a, Http_send)), (_arg) => {
                const response = _arg;
                return (response.statusCode === 200) ? singleton.Return(parseFn(response.responseText)) : singleton.Return(new FSharpResult$2(1, response.responseText));
            });
        });
    }
}

export function saveAnnulFee(clientNr, feeNr) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, toText(printf("/Fees/Annul/%i/%i"))(clientNr)(feeNr)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        const record = some({});
        const requestCaseStrategy_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        let parseFn;
        const arg_2 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(string_type, string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(string_type, arg_2, Http_get_ExtraCoders().Value)), str);
        });
        const jsonStr = toString(0, Auto_generateBoxedEncoder_Z20B7B430(option_type(obj_type), requestCaseStrategy_1, Http_get_ExtraCoders().Value, false)(record));
        return singleton.Delay(() => {
            let a;
            return singleton.Bind((a = getCsrfEnabledRequest(addClientReference(Http_withCredentials(true, Http_content(new BodyContent(1, jsonStr), Http_method(new HttpMethod(2), Http_request(ValidatedUrlModule_value(matchValue.fields[0]))))))), singleton.Bind(a, Http_send)), (_arg) => {
                let response_1;
                return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(string_type, string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
            });
        });
    }
}

export function loadInvoiceeFees(clientNr, invoiceeNr) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(1, `/fees/${clientNr}/?invoiceeNr=${invoiceeNr}&includeNoNextInvoice=false&includeFinalInvoiced=false`));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        let parseFn;
        const arg = defaultArg(new CaseStrategy(1), new CaseStrategy(0));
        parseFn = ((arg_1) => {
            const str = arg_1;
            return equals(list_type(FeeDTO$reflection()), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(list_type(FeeDTO$reflection()), arg, Http_get_ExtraCoders().Value)), str);
        });
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(list_type(FeeDTO$reflection()), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

export function Thunks_loadInvoiceeFeesThunk(clientNr, invoiceeNr) {
    return createThunk((dispatch) => ((getState) => {
        if (getState().Invoicee.InvoiceeFees.tag === 1) {
        }
        else {
            const dispatchSetInvoiceeFeesAction = (arg) => {
                dispatch(setInvoiceeFees(arg));
            };
            if (getState().Invoicee.InvoiceeFees.tag === 2) {
            }
            else {
                dispatchSetInvoiceeFeesAction(new LoadState$2(1));
            }
            startImmediate(singleton.Delay(() => singleton.Bind(loadInvoiceeFees(clientNr, invoiceeNr), (_arg) => {
                const result = _arg;
                dispatchSetInvoiceeFeesAction((result.tag === 1) ? (new LoadState$2(3, result.fields[0])) : (new LoadState$2(2, result.fields[0])));
                return singleton.Zero();
            })));
        }
    }));
}

